export default __webpack_public_path__ + "static/media/YuhaiNadan.88a8c489.jpg";